import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_dialog = _resolveComponent("cus-dialog")

  return (_openBlock(), _createBlock(_component_cus_dialog, {
    title: _ctx.title,
    operation: _ctx.operation,
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible = $event)),
    onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearForm())),
    onOperate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleCreateOrUpdate())),
    processing: _ctx.loading,
    width: "700px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef",
        size: "small",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "SEQ",
            prop: "seq"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.seq,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.seq = $event)),
                maxlength: "2",
                disabled: _ctx.operation === _ctx.DialogGenre.Edit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "分類",
            prop: "bunruiCd"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.bunruiCd,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.bunruiCd = $event)),
                "popper-class": "shonin-comment-bunrui"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bunruiList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.bunrui,
                      value: item.bunrui_cd
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "承認コメント",
            prop: "shoninComment",
            class: "xl-input"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                autosize: { minRows: 6 },
                modelValue: _ctx.form.shoninComment,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.shoninComment = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "operation", "modelValue", "processing"]))
}